import InputFile, { UploadFileProps } from '@anm/components/InputFile';
import { FC } from 'react';

export type UploadedLogoProps = {
  name: string;
  iconSrc: string;
};

type NewLogoProps = {
  accept: string;
  onUpload: (props: UploadFileProps) => void;
};

const NewLogo: FC<NewLogoProps> = ({ onUpload, ...otherProps }) => (
  <label>
    <InputFile {...otherProps} handleUpload={(p: UploadFileProps[]) => onUpload(p[0])} />
  </label>
);

export default NewLogo;
